export default {"src":"/_next/static/media/4.1f618498.svg","height":38,"width":38,"blurWidth":0,"blurHeight":0};